(function attachClarityCommerce(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.initialize(root, root.document);
})(typeof globalThis === 'undefined' ? window : globalThis, function createClarityCommerce() {
  const actions = new Set([
    'option_selected', 'add_to_cart_attempt', 'size_required', 'add_to_cart_success',
    'add_to_cart_error', 'cart_drawer_error', 'checkout_click', 'size_guide_open',
    'product_details_open',
  ]);

  function createTracker(env, context) {
    let tagged = false;
    function allowed() {
      try {
        return env.location.hostname === 'monci.hr' && !env.Shopify?.designMode
          && !new URLSearchParams(env.location.search).has('preview_theme_id')
          && env.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true
          && typeof env.clarity === 'function';
      } catch { return false; }
    }
    function tagContext() {
      if (!allowed()) return false;
      if (tagged) return true;
      try {
        env.clarity('set', 'monci_page_type', context.pageType || 'other');
        if (context.product) env.clarity('set', 'monci_product', context.product);
        env.clarity('set', 'monci_locale', context.locale || 'hr');
        const query = new URLSearchParams(env.location.search);
        let isTest = query.get('utm_source') === 'codex' || query.get('utm_medium') === 'qa';
        try {
          isTest = isTest || env.sessionStorage?.getItem('monci:clarity-qa') === 'yes';
          if (isTest) env.sessionStorage?.setItem('monci:clarity-qa', 'yes');
        } catch { /* Restricted storage must not affect shopping or consent checks. */ }
        env.clarity('set', 'monci_test_session', isTest ? 'yes' : 'no');
        tagged = true;
        return true;
      } catch { return false; }
    }
    function track(action) {
      if (!actions.has(action) || !allowed() || !tagContext()) return false;
      try {
        env.clarity('event', `monci_${action}`);
        return true;
      } catch { return false; }
    }
    return { track, tagContext, resetContext: () => { tagged = false; } };
  }

  function initialize(env, doc) {
    const config = doc.querySelector('script[data-monci-clarity]');
    if (!config || config.dataset.ready === 'true') return;
    config.dataset.ready = 'true';
    const tracker = createTracker(env, {
      pageType: config.dataset.pageType,
      product: config.dataset.product,
      locale: config.dataset.locale,
    });
    let timer;
    function syncContext(attempt = 0) {
      env.clearTimeout(timer);
      if (tracker.tagContext() || attempt >= 15) return;
      timer = env.setTimeout(() => syncContext(attempt + 1), 1000);
    }
    doc.addEventListener('monci:commerce', (event) => tracker.track(event.detail?.action));
    doc.addEventListener('change', (event) => {
      if (event.target.matches?.('input, select') && event.target.closest('[data-option-group]')) {
        tracker.track('option_selected');
      }
    });
    doc.addEventListener('submit', (event) => {
      if (event.submitter?.name === 'checkout') tracker.track('checkout_click');
    }, { capture: true });
    doc.addEventListener('click', (event) => {
      const summary = event.target.closest?.('summary');
      const details = summary?.parentElement;
      if (!details || details.open || event.defaultPrevented) return;
      if (details.matches('[data-product-size-guide]')) tracker.track('size_guide_open');
      if (details.matches('[data-product-description-accordion]')) tracker.track('product_details_open');
    });
    doc.addEventListener('visitorConsentCollected', () => {
      tracker.resetContext();
      syncContext();
    });
    if (!env.Shopify?.customerPrivacy && typeof env.Shopify?.loadFeatures === 'function') {
      env.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        if (!error) syncContext();
      });
    }
    syncContext();
  }
  return { createTracker, initialize };
});
